import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@shared/context/AuthContext";
import { resolveAuthenticatedRedirectTarget } from "@shared/utils/authRouting";

const RequireAnonymous: React.FC = () => {
  const { isAuthenticated, authCheckLoading } = useAuth();
  const location = useLocation();

  // Avoid unmounting login chrome while the pathname auth check settles
  // (returning null caused a visible blank → remount "auto-loading" flash).
  if (authCheckLoading) {
    if (isAuthenticated) {
      return (
        <Navigate
          to={resolveAuthenticatedRedirectTarget(location.state)}
          replace
        />
      );
    }
    return <Outlet />;
  }

  if (isAuthenticated) {
    return (
      <Navigate
        to={resolveAuthenticatedRedirectTarget(location.state)}
        replace
      />
    );
  }

  return <Outlet />;
};

export default RequireAnonymous;
